import request from '@/config/axios'

export interface CleaningVO {
  id: string | number
  shopId: string | number
  roomId: string | number
  roomNo?: string
  taskType: number // 退房/日常/深度
  status: number // 0待分配/1已分配/2清洁中/3待验收/4已完成/5已取消
  assigneeId?: string | number
  assigneeName?: string
  assignTime?: string
  startTime?: string
  completeTime?: string
  verifyUser?: string
  verifyTime?: string
  verifyRemark?: string
  remark?: string
  createTime?: string
}

export interface AssignDTO {
  id: string | number
  assigneeId: string | number
  assigneeName: string
}

export interface VerifyDTO {
  id: string | number
  verifyUser: string
  verifyRemark?: string
}

// 清洁任务分页查询
export const getCleaningPage = (params: any) => {
  return request.get({ url: '/hotel/cleaning/page', params })
}

// 分配清洁任务
export const assign = (data: AssignDTO) => {
  return request.put({ url: '/hotel/cleaning/assign', data })
}

// 开始清洁
export const start = (id: string | number) => {
  return request.put({ url: '/hotel/cleaning/start', data: { id } })
}

// 完成清洁
export const complete = (id: string | number) => {
  return request.put({ url: '/hotel/cleaning/complete', data: { id } })
}

// 验收清洁
export const verify = (data: VerifyDTO) => {
  return request.put({ url: '/hotel/cleaning/verify', data })
}

// 取消清洁
export const cancel = (id: string | number, reworkReason?: string) => {
  return request.put({ url: '/hotel/cleaning/cancel', data: { id } })
}
